<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader style="max-width: 555px" v-bind="attrs" type="card" v-if="isLoading">
			</v-skeleton-loader>
			<div
				v-if="!isLoading && uploads.length > 0"
				v-for="attachment in uploads"
				:key="uploads.id"
				class="mt-1"
			>
				<div class="action-resources-page__file-container d-flex">
					<div class="d-flex">
						<div class="d-flex align-center">
							<PostAttachments :attachment="attachment" backgroundColor="#F3F3F6" />
						</div>
						<div class="action-resources-page__file-container__wrapper">
							<a
								class="action-resources-page__file-container__wrapper__title"
								:href="attachment.url"
								target="_blank"
							>
								{{ attachment.file_real_name }}
							</a>
							<span
								class="action-resources-page__file-container__wrapper__description"
							>
								{{ attachment.file_description }}
							</span>
						</div>
					</div>
					<span class="action-resources-page__file-container__wrapper__date mt-2">
						{{ dateCreated(attachment.time) }}
					</span>
				</div>
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import UploadList from '@/components/Resource/UploadList.vue'
import ButtonBack from '@/components/ButtonBack.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Pagination from '@/components/Pagination.vue'
import PostAttachments from '@/components/Post/PostAttachments.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'

export default {
	name: 'SessionFilesPage',
	mixins: [Block],
	components: {
		NewsFeedEmpty,
		PostAttachments,
		Pagination,
		UploadList,
		ButtonBack,
		PageBlocked,
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'listMeta']),
		...mapGetters('event', ['event', 'isLoading', 'session']),

		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		uploads() {
			if (!this.session) {
				return []
			}
			return this.session.uploads
		},
		resourcesItems() {
			return this.resourcesList || []
		},
		pageCount() {
			if (!this.listMeta) {
				return 0
			}

			return +this.listMeta.pageCount
		},
	},
	methods: {
		...mapActions('resources', ['getResources']),
		...mapActions('event', ['getEvent', 'getSession']),
		...mapActions('app', ['setPageTitle']),
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			return date.toLocaleString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				timeZone: 'UTC',
			})
		},

		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		onPageChange(page) {
			const params = {
				search: this.filters.search,
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getResources(queryString)
		},
		formatFilters(filters) {
			const { search, page } = filters

			let queryString = `page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},
		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getResources(queryString)
			}, 500)
		},
	},
	mounted() {
		this.setPageTitle('Files')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	data() {
		return {
			searchIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			filters: {
				page: 1,
				search: '',
			},
			pageBlockedName: 'events',
		}
	},
	created() {
		if (
			this.$route.params.eventId !== undefined &&
			this.$route.params.sessionId !== undefined &&
			(!this.isBlocked || this.isBlocked === null)
		) {
			this.getEvent(this.$route.params.eventId)
			this.getSession(this.$route.params.sessionId)
		}
	},
}
</script>

<style lang="scss">
.settings-page {
	&.v-tabs {
		font-style: normal;
		font-weight: bold !important;
		font-size: 20px;
		line-height: 67px;
		text-transform: capitalize;
		justify-content: space-between;
		letter-spacing: 0.1px !important;
	}

	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}

	&__tabs {
		.v-tab {
			justify-content: space-between;
			font-style: normal;
			font-weight: 900;
			font-size: 20px;
			line-height: 67px;
			text-transform: capitalize;
			color: #cbcbcb !important;

			&--active {
				color: #4d536e !important;
			}
		}
	}

	@media screen and (max-width: 960px) {
		.settings-page__title {
			font-size: 25px !important;
		}
		.v-tabs-bar {
			display: contents;
		}
		.v-tab {
			font-size: 18px !important;
		}
	}
	@media screen and (max-width: 600px) {
		.v-card__text {
			padding: 0;
		}
		.v-tab {
			padding: 0 3px;
		}
	}
}
</style>
